var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel--video" },
    [
      _vm.title && _vm.videos.length > 0
        ? _c("h2", { staticClass: "carousel__title" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        : _vm._e(),
      !_vm.disableScroll
        ? _c(
            "div",
            { staticClass: "carousel__nav" },
            [
              _c("v-button", {
                staticClass: "carousel__nav__prev",
                attrs: { label: "Previous Slide", icon: "arrow-left" },
                on: {
                  click: function($event) {
                    return _vm.$refs.videoCarousel.slidePrev()
                  }
                }
              }),
              _c("v-button", {
                staticClass: "carousel__nav__next",
                attrs: { label: "Next Slide", icon: "arrow-right" },
                on: {
                  click: function($event) {
                    return _vm.$refs.videoCarousel.slideNext()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "carousel",
        {
          ref: "videoCarousel",
          attrs: {
            "center-mode": _vm.centerMode,
            infinite: _vm.infiniteScroll,
            "slides-to-show": _vm.slidesToShow
          },
          on: { "before-slide": _vm.beforeSlide, "after-slide": _vm.afterSlide }
        },
        _vm._l(_vm.videos, function(video, index) {
          return _c(
            "slide",
            { key: index + "_" + video.id },
            [
              _c("video-thumbnail", {
                attrs: {
                  title: video.title,
                  description: video.description,
                  image: video.image,
                  "mobile-image": video.mobileImage,
                  alt: video.title,
                  "video-id": video.id,
                  showDescription:
                    _vm.disableScroll || index === _vm.activeIndex,
                  "overlay-color": video.overlayColor,
                  "overlay-opacity": video.overlayOpacity
                },
                on: {
                  focused: function($event) {
                    return _vm.$root.$emit("videoSlideTo", index)
                  }
                }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }